export const signupConstants = {
  SIGNUP_PROCESSING: "SIGNUP_PROCESSING",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  SIGNUP_FAILURE: "SIGNUP_FAILURE",

  CHECK_USER_EXISTENCE_PROCESSING: "CHECK_USER_EXISTENCE_PROCESSING",
  CHECK_USER_EXISTENCE_SUCCESS: "CHECK_USER_EXISTENCE_SUCCESS",
  CHECK_USER_EXISTENCE_FAILURE: "CHECK_USER_EXISTENCE_FAILURE"
};
